import { Injectable } from '@angular/core';
import { BaseServiceErrorResolverService } from 'src/app/core/services/error-resolvers/base-service-error-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class ComplaintServiceErrorResolverService extends BaseServiceErrorResolverService {}
